import { enableMocking } from '@configs/enableMocking';
import { initializeHeap } from '@configs/heap/initializeHeap';
import { loadOneTrustScripts } from '@configs/one-trust/loadOneTrustScripts';
import { LaunchDarklyProvider } from '@contexts/launch-darkly-provider/LaunchDarklyProvider';
import { MsalAuthProvider } from '@contexts/msal-provider';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './i18n';

await enableMocking();

loadOneTrustScripts();
initializeHeap();

createRoot(document.getElementById('root') as HTMLElement).render(
  <MsalAuthProvider>
    <LaunchDarklyProvider>
      <App />
    </LaunchDarklyProvider>
  </MsalAuthProvider>
);
